export default __webpack_public_path__ + "static/media/mobile_82.fbe2cc61.jpg";